import axios from '../api/index'
export const getActasEnc = async () =>{
    return await axios.request('get',`/actasenc`)
        .then(res => Promise.resolve(res.data))
}